export const setLocalStorageItem = (itemKey, itemValue) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    window.localStorage.setItem(itemKey, JSON.stringify(itemValue))
  }
}

export const getLocalStorageItem = (itemKey, defaultValue) => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const result = JSON.parse(window.localStorage.getItem(itemKey))
    return result == null ? defaultValue : result
  } else {
    return defaultValue
  }
}
